import { render, staticRenderFns } from "./OptionBtn.vue?vue&type=template&id=2e32d9b2&"
import script from "./OptionBtn.vue?vue&type=script&lang=js&"
export * from "./OptionBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./OptionBtn.vue?vue&type=custom&index=0&blockType=styles&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports